<template>
  <div class="columns is-multiline column-box">
    <div
      v-for="(aTemplate,index) in templates"
      :key="aTemplate.id"
      class="column is-4 is-two-thirds-tablet has-text-centered image-box"
    >
      <div class="image_wrapper">
        <img
          class="template_image"
          :src="aTemplate.imageUrl"
          :alt="aTemplate.name"
          @click="$emit('preview', index)"
        >
        <div
          class="overlay"
          @click="$emit('preview', index)"
        >
          <div class="text is-uppercase">
            {{ $t('templatepicker.view_template.tag') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {

  name: 'TemplateListing',

  props: {
    templates: {
      type: Array,
      default: function () {
        return []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../sass/_variables.scss';

  .column-box {
    background-color: #ecf0f1;
    margin-bottom: 10px;
    margin-top: 0px;

    @media (min-width:1020px) {

      margin-bottom: 0px;
      margin-top: 10px;
    }
  }

  .image-box {
    background-color: #ecf0f1;
    z-index: 2;
  }

  .image_wrapper {
    position: relative;
    transition: transform .15s ease;

    img {
      box-shadow: 0 0 10px rgba(0,0,0,.25);
    }

    &:hover {
      transform: scale(1.02);
    }

    &:hover .overlay {
      height: 20%;
    }

    .overlay {
      position: absolute;
      bottom: 6px;
      left: 0;
      right: 0;
      background-color: var(--primary-color);
      overflow: hidden;
      width: 100%;
      height: 0;
      opacity: .9;
      transition: .5s ease;
      cursor: pointer;
    }

    .text {
      padding-top: 15px;
    }
  }
</style>
